<div #scrollContainer class="phx-table-scroll-container">
  <table #tableElement class="phx-table-element" [style.min-width]="cachedTableMinWidth">
    <!-- Column widths and alignment via native <colgroup> -->
    <colgroup>
      <col *ngIf="phxSelectable" [style.width.px]="checkboxColWidth" />
      <col
        *ngFor="let column of visibleColumns; let colIndex = index; trackBy: trackByColumnKey"
        [style.width]="getColumnColWidth(column, colIndex, visibleColumns)"
      />
    </colgroup>

    <!-- Column group header row (super headers) — derived from phxColumnGroups -->
    <thead #tableHead class="phx-table-head">
      <ng-container *ngIf="hasColumnGroups">
        <tr class="phx-table-group-row">
          <th
            *ngIf="phxSelectable"
            class="phx-table-group-header phx-table-group-header-empty phx-table-group-border-left"
          ></th>
          <ng-container *ngFor="let segment of columnGroupSegments">
            <th
              *ngIf="!segment.isUngrouped"
              class="phx-table-group-header"
              [class.phx-table-group-border-left]="segment.borderLeft"
              [class.phx-table-group-border-right]="segment.borderRight"
              [attr.colspan]="segment.colspan"
            >
              {{ segment.header }}
            </th>
            <th
              *ngIf="segment.isUngrouped"
              class="phx-table-group-header phx-table-group-header-empty"
              [class.phx-table-group-border-right]="segment.borderRight"
              [attr.colspan]="segment.colspan"
            ></th>
          </ng-container>
        </tr>
      </ng-container>

      <!-- Primary header row -->
      <tr class="phx-table-header-row">
        <th
          *ngIf="phxSelectable"
          class="phx-table-header-cell phx-table-control-cell"
          [phxStickyCol]="getStickyInfo(-1)"
          (click)="$event.stopPropagation()"
        >
          <phx-checkbox
            [phxChecked]="isAllSelected"
            [phxIndeterminate]="isIndeterminate"
            (phxCheckedChange)="onSelectAllChange($event)"
          ></phx-checkbox>
        </th>
        <th
          *ngFor="let column of visibleColumns; let vi = index; trackBy: trackByColumnKey"
          phx-table-cell-header
          [phxColumn]="column"
          [phxHeaderConfigs]="getHeaderConfigs(column)"
          [phxStickyCol]="getStickyInfo(getFullIndex(vi))"
          [phxGroupBorderRight]="isGroupBorderColumn(getFullIndex(vi))"
          [phxSortKey]="phxSortKey"
          [phxSortDirection]="phxSortDirection"
          (phxSortChange)="onHeaderSortChange($event)"
        ></th>
      </tr>
    </thead>

    <tbody class="phx-table-body">
      <ng-container *ngIf="!isLoading; else loadingSkeleton">
        <ng-container *ngIf="data?.length; else emptyState">
          <ng-content></ng-content>
        </ng-container>
      </ng-container>

      <!-- Loading skeleton rows -->
      <ng-template #loadingSkeleton>
        <tr *ngFor="let _ of cachedSkeletonRows" class="phx-table-skeleton-row">
          <td *ngIf="phxSelectable" class="phx-table-skeleton-cell phx-table-control-cell">
            <phx-skeleton phxWidth="20px" phxHeight="20px" phxShape="rounded"></phx-skeleton>
          </td>
          <td
            *ngFor="let col of visibleColumns; trackBy: trackByColumnKey"
            class="phx-table-skeleton-cell"
            [class.phx-table-align-right]="col.align === 'right'"
            [class.phx-table-align-center]="col.align === 'center'"
          >
            <phx-skeleton
              [phxWidth]="col.width || '70%'"
              phxHeight="14px"
              phxShape="rounded"
              [phxPosition]="col.align || 'left'"
              [phxDirection]="'column'"
            ></phx-skeleton>
          </td>
        </tr>
      </ng-template>

      <!-- Empty state -->
      <ng-template #emptyState>
        <tr class="phx-table-empty-row">
          <td [attr.colspan]="totalColumns" class="phx-table-empty-cell">
            <div class="phx-table-empty-content">
              <i phx-icon [phxIcon]="phxEmptyStateIcon" [size]="64" class="phx-table-empty-icon"></i>
              <span class="phx-table-empty-text">{{ phxEmptyStateText ?? ('No data available' | phxTranslate) }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</div>

<phx-table-pagination
  *ngIf="!phxHidePagination"
  [totalItems]="phxTotalItems"
  [hasNextPage]="paginationHasNextPage"
  [perPage]="phxPerPage"
  [currentPage]="phxCurrentPage"
  [perPageOptions]="phxPerPageOptions"
  [lastUpdatedAtLabel]="lastUpdatedAtLabel"
  [lastUpdatedAtRelativeLabel]="lastUpdatedAtRelativeLabel"
  (pageChange)="onPageChange($event)"
></phx-table-pagination>

<phx-table-column-customizer
  [phxOpen]="phxColumnCustomizerOpen"
  [phxColumnsConfig]="phxColumnsConfig"
  (phxOpenChange)="onColumnCustomizerOpenChange($event)"
  (phxColumnsConfigChange)="onCustomizerColumnsConfigChange($event)"
></phx-table-column-customizer>
